import React from 'react';
import TableView from '../tableView';
import { OrdersInfo } from '../../Model/contact';
import { useTranslation } from 'react-i18next';

interface Props {
  ordersInfo: OrdersInfo[],
  tabulator: any,
  filterSelectOptions: {}
}

const OrderTable = ({
  filterSelectOptions,
  ordersInfo,
  tabulator
}: Props) => {
  const { t } = useTranslation();
  const orderColumns = [
    {
      title: t('SOURCE'),
      field: 'source',
      sorter: 'string',
      headerFilter: 'input',
      editorParams: filterSelectOptions,
      headerFilterParams: filterSelectOptions
    },
    {
      title: t('ORDERS'),
      field: 'orders',
      sorter: 'string',
      headerFilter: 'input',
      editorParams: filterSelectOptions,
      headerFilterParams: filterSelectOptions
    }
  ];

  return <> {ordersInfo.length > 0
    ? <TableView
      t={t}
      ref={tabulator}
      data={ordersInfo}
      columns={orderColumns}
      id={'orders-list'} />
    : <p className='noData'>{t('NO_DATA')}</p>
  }
  </>;
};

export default OrderTable;